import type {Router, RouteRecordRaw} from 'vue-router';

import {usePermissionStoreWithOut} from '/@/store/modules/permission';

import {PageEnum} from '/@/enums/pageEnum';
import {useUserStoreWithOut} from '/@/store/modules/user';

import {PAGE_NOT_FOUND_ROUTE} from '/@/router/routes/basic';
import {getCookie, LOGO_COOKIE_KEY} from "/@/utils/cache/cookie";
import {useLoginState} from "/@/views/sys/login/useLogin";
import {useAppStoreWithOut} from "/@/store/modules/app";

const LOGIN_PATH = PageEnum.BASE_LOGIN;

// const LOGIN_PATH = userStore.getUserInfo.homePath

// const ROOT_PATH = RootRoute.path;

// const whitePathList = [userStore.getUserInfo.homePath];
const whitePathList: PageEnum[] = [LOGIN_PATH/*, PageEnum.BASE_CENTER*/];

export function createPermissionGuard(router: Router) {
    const userStore = useUserStoreWithOut();
    // const userStorePromiss = usePermissionStore()
    const permissionStore = usePermissionStoreWithOut();
    router.beforeEach(async (to, from, next) => {
        if (whitePathList.includes(to.path as PageEnum)) {
            next();
            return;
        }
        // get userinfo while last fetch time is empty
        if (userStore.getLastUpdateTime === 0) {
            // await userStore.checkServiceStatus();//无网络情况
            try {
                // 获取健康产品id
                // useAppStoreWithOut().setHlCategoryId();

                // 无登录状态下不获取用户信息
                const searchParams = new URLSearchParams(window.location.search);
                // console.log(searchParams.get('otoken'))
                // const fileType = searchParams.get('fileType');
                if ((getCookie(LOGO_COOKIE_KEY) && userStore.getServiceStatus) || searchParams?.get('otoken')) {
                    await userStore.checkUserInfoAction();
                    if (useLoginState().getLoginState) {
                        await userStore.getUserInfoAction();
                    }
                } else {
                    useLoginState().setLoginState(0);
                }
            } catch (err) {
                next();
                return;
            }
        }

        if (permissionStore.getIsDynamicAddedRoute) {
            next();
            return;
        }

        const routes = await permissionStore.buildRoutesAction();

        routes.forEach((route) => {
            router.addRoute(route as unknown as RouteRecordRaw);
        });

        router.addRoute(PAGE_NOT_FOUND_ROUTE as unknown as RouteRecordRaw);

        permissionStore.setDynamicAddedRoute(true);

        if (to.name === PAGE_NOT_FOUND_ROUTE.name) {
            // 动态添加路由后，此处应当重定向到fullPath，否则会加载404页面内容
            next({path: to.fullPath, replace: true, query: to.query});
        } else {
            // const redirectPath = (from.query.redirect || to.path) as string;
            // const redirect = decodeURIComponent(redirectPath);
            // const nextData = to.path === redirect ? {...to, replace: true} : {path: redirect};
            // next(nextData);

            const redirectPath = (from.query.redirect || to.path) as string;
            const redirect = decodeURIComponent(redirectPath);
            const isValidRoute = router.getRoutes().some(route => route.path === redirect);
            next({
                path: isValidRoute ? redirect : to.path,
                query: to.query,
                replace: true
            });
        } 
    });
}
